/**
 * ProfilePanel — read-only display of the signed-in user's profile.
 *
 * Reads the authenticated user from {@link useUser}; profile editing is out of
 * scope for C18 (no write endpoint yet), so the fields are shown disabled.
 */
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";
import { useUser } from "@/auth/AuthProvider";

export function ProfilePanel(): ReactElement {
  const user = useUser();

  return (
    <Box>
      <Typography variant="h6" component="h2" gutterBottom>
        Profile
      </Typography>
      <Stack spacing={2} sx={{ maxWidth: 480 }}>
        <TextField
          label="Display name"
          value={user?.displayName ?? ""}
          disabled
          fullWidth
          slotProps={{ input: { readOnly: true } }}
        />
        <TextField
          label="Email"
          value={user?.email ?? ""}
          disabled
          fullWidth
          slotProps={{ input: { readOnly: true } }}
        />
      </Stack>
    </Box>
  );
}
